import { downloadFile } from '@utils/browser';

import { request } from '../request';

export const uploadFile = async (data: { path: string; file: File; overwriteFile: boolean }) => {
  const response = await request.postForm(`v1/files/upload/`, data);
  return response.data;
};

export const getUploadedFileUrl = async (path: string) => {
  const response = await request.get<{ url: string }>(`v1/files/uploaded/?path=${path}`);
  return response.data;
};

export const exportCsvToExcel = async (csvContent: string) => {
  const formData = new FormData();
  formData.append('file', new Blob([csvContent], { type: 'text/csv;charset=utf-8' }), 'export.csv');
  const response = await request.post(`v1/files/exports/excel/`, formData, {
    responseType: 'blob',
  });
  downloadFile(response.data, 'export.xlsx');
};

export const exportCsvToGoogleSheet = async (csvContent: string, filename?: string) => {
  const response = await request.post<{
    spreadsheetUrl?: string;
    needsAuth?: boolean;
    authUrl?: string;
  }>(`v1/files/exports/google-sheet/`, {
    csv: csvContent,
    filename,
  });
  return response.data;
};
